// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {

  --fontFamily: Roboto, sans-serif;
  --mainBackground: #fff;
  --dimBackground: #f9fafb;
  --mainForeground: #262626;
  --dimForeground: #6d7283;
  --primaryForeground: #315efb;
  --successForeground: #28bc00;
  --warningForeground: #f4c914;
  --failureForeground: #ff564e;
  --lightGrayBlue: #e8eaf0;
  --greyishBlue: #6674a6;
  --cloudGray: #8d96b2;
  --battleshipGrey: #62687f;
  --carbone: #343b4c;
}

.src-components-ProfileItem-styles--root--pZ5d3 {
  position: relative;
  box-sizing: border-box;
  margin-left: 10px;
  margin-right: 10px;
  padding: 20px 0;
  min-height: 55px;
  font-size: 14px;
  text-align: left;
  line-height: 0;
}

@media screen and (min-width: 768px) {

.src-components-ProfileItem-styles--root--pZ5d3 {
    margin-left: 0;
    margin-right: 0;
    font-size: 13px;
    line-height: 0;
}
  }

.src-components-ProfileItem-styles--root--pZ5d3 + section::before,.src-components-ProfileItem-styles--root--pZ5d3 + form::before {
    position: absolute;
    top: -1px;
    left: 0;
    right: 0;
    height: 1px;
    background-color: #e8eaf0;
    background-color: var(--lightGrayBlue);
    content: '';
  }

.src-components-ProfileItem-styles--content--xEXjI {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
}

@media screen and (min-width: 768px) {

.src-components-ProfileItem-styles--content--xEXjI {
    align-items: center;
}
  }

.src-components-ProfileItem-styles--content--xEXjI h5,
.src-components-ProfileItem-styles--content--xEXjI h5 a,
.src-components-ProfileItem-styles--content--xEXjI h5 small,
.src-components-ProfileItem-styles--content--xEXjI h5 button {
  font-size: inherit;
  line-height: 1.07;
}

@media screen and (min-width: 768px) {

.src-components-ProfileItem-styles--content--xEXjI h5,
.src-components-ProfileItem-styles--content--xEXjI h5 a,
.src-components-ProfileItem-styles--content--xEXjI h5 small,
.src-components-ProfileItem-styles--content--xEXjI h5 button {
    line-height: 1.2;
}
  }

.src-components-ProfileItem-styles--content--xEXjI h5,
.src-components-ProfileItem-styles--content--xEXjI h5 div,
.src-components-ProfileItem-styles--content--xEXjI h5 strong {
  overflow: hidden;
  text-overflow: ellipsis;
}

.src-components-ProfileItem-styles--content--xEXjI h5 {
  flex: 1 1;
  margin-top: 0;
  margin-bottom: 0;
  font-weight: 400;
}

@media screen and (min-width: 768px) {

.src-components-ProfileItem-styles--content--xEXjI h5 {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}
  }

.src-components-ProfileItem-styles--content--xEXjI h5[disabled] {
  color: #b0b4c2;
}

.src-components-ProfileItem-styles--content--xEXjI h5 strong {
  font-weight: 500;
}

.src-components-ProfileItem-styles--content--xEXjI h5 small {
  color: #b0b4c2;
}

.src-components-ProfileItem-styles--content--xEXjI h5 a,
.src-components-ProfileItem-styles--content--xEXjI h5 button {
  display: inline-block;
  border: 0 !important;
  outline: 0;
  margin: 0;
  margin: initial;
  padding: 0;
  padding: initial;
  background-color: transparent;
  font-weight: 400;
  text-align: left;
  cursor: pointer;
}

@media screen and (min-width: 768px) {

.src-components-ProfileItem-styles--content--xEXjI h5 a,
.src-components-ProfileItem-styles--content--xEXjI h5 button {
    white-space: nowrap;
}
  }

.src-components-ProfileItem-styles--content--xEXjI h5 div > svg {
  margin-left: 5px;
}

.src-components-ProfileItem-styles--content--xEXjI h5 button svg {
  vertical-align: top;
}

.src-components-ProfileItem-styles--content--xEXjI > :nth-child(1n + 2):not(span) {
  margin-left: 20px;
}

.src-components-ProfileItem-styles--content--xEXjI h5 > :nth-child(1n + 2) {
  display: inline-block;
  margin-top: 15px;
}

@media screen and (min-width: 768px) {

.src-components-ProfileItem-styles--content--xEXjI h5 > :nth-child(1n + 2) {
    display: inherit;
    margin-top: 0;
}
  }

.src-components-ProfileItem-styles--content--xEXjI h5 > :nth-child(1n + 2) > :nth-child(1n + 2) {
    margin-top: 0;
    margin-left: 15px;
  }

.src-components-ProfileItem-styles--content--xEXjI h5 > :first-child > :nth-child(1n + 2):not(svg) {
  display: block;
  margin-top: 5px;
}

@media screen and (min-width: 768px) {

.src-components-ProfileItem-styles--content--xEXjI h5 > :first-child > :nth-child(1n + 2):not(svg) {
    display: inline-block;
    margin-top: 0;
    margin-left: 15px;
}
  }

.src-components-ProfileItem-styles--footer--wlDTW {
  margin-top: 5px;
  line-height: 1.07;
}

@media screen and (min-width: 768px) {

.src-components-ProfileItem-styles--footer--wlDTW {
    line-height: 1.2;
}
  }

.src-components-ProfileItem-styles--footer--wlDTW > span {
    display: block;
    width: 100%;
    margin-top: 20px;
    color: #ff564e;
    color: var(--failureForeground);
  }
`, "",{"version":3,"sources":["webpack://./src/utils/variables.css","webpack://./src/components/ProfileItem/styles.css"],"names":[],"mappings":"AAAA;;EAQE,gCAAgC;EAChC,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,wBAAwB;EACxB,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,wBAAwB;EACxB,sBAAsB;EACtB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;AACpB;;ACpBA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAmBhB;;AAjBE;;AAXF;IAYI,cAAc;IACd,eAAe;IACf,eAAe;IACf,cAAc;AAalB;EAZE;;AAEA;IAEE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,WAAW;IACX,yBAAsC;IAAtC,sCAAsC;IACtC,WAAW;EACb;;AAGF;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;AAKzB;;AAHE;;AANF;IAOI,mBAAmB;AAEvB;EADE;;AAGF;;;;EAIE,kBAAkB;EAClB,iBAAiB;AAKnB;;AAHE;;AAPF;;;;IAQI,gBAAgB;AAEpB;EADE;;AAGF;;;EAGE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAQlB;;AANE;;AANF;IAOI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AAEvB;EADE;;AAGF;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,oBAAoB;EACpB,UAAU;EACV,SAAe;EAAf,eAAe;EACf,UAAgB;EAAhB,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AAKjB;;AAHE;;AAZF;;IAaI,mBAAmB;AAEvB;EADE;;AAGF;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAWlB;;AATE;;AAJF;IAKI,gBAAgB;IAChB,aAAa;AAOjB;EANE;;AAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;AAGF;EACE,cAAc;EACd,eAAe;AAOjB;;AALE;;AAJF;IAKI,qBAAqB;IACrB,aAAa;IACb,iBAAiB;AAErB;EADE;;AAGF;EACE,eAAe;EACf,iBAAiB;AAYnB;;AAVE;;AAJF;IAKI,gBAAgB;AASpB;EARE;;AAEA;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,cAA+B;IAA/B,+BAA+B;EACjC","sourcesContent":[":root {\n  @custom-media --mobile screen and (width < 768px);\n  @custom-media --desktop screen and (width >= 768px);\n  @custom-media --desktop-l screen and (width >= 1024px);\n  @custom-media --desktop-x screen and (width >= 1280px);\n  @custom-media --desktop-xl screen and (width >= 1440px);\n  @custom-media --iphone screen and (max-device-width: 736px) and (-webkit-min-device-pixel-ratio: 2);\n\n  --fontFamily: Roboto, sans-serif;\n  --mainBackground: #fff;\n  --dimBackground: #f9fafb;\n  --mainForeground: #262626;\n  --dimForeground: #6d7283;\n  --primaryForeground: #315efb;\n  --successForeground: #28bc00;\n  --warningForeground: #f4c914;\n  --failureForeground: #ff564e;\n  --lightGrayBlue: #e8eaf0;\n  --greyishBlue: #6674a6;\n  --cloudGray: #8d96b2;\n  --battleshipGrey: #62687f;\n  --carbone: #343b4c;\n}\n","@import 'utils/variables.css';\n\n.root {\n  position: relative;\n  box-sizing: border-box;\n  margin-left: 10px;\n  margin-right: 10px;\n  padding: 20px 0;\n  min-height: 55px;\n  font-size: 14px;\n  text-align: left;\n  line-height: 0;\n\n  @media (--desktop) {\n    margin-left: 0;\n    margin-right: 0;\n    font-size: 13px;\n    line-height: 0;\n  }\n\n  & + section::before,\n  & + form::before {\n    position: absolute;\n    top: -1px;\n    left: 0;\n    right: 0;\n    height: 1px;\n    background-color: var(--lightGrayBlue);\n    content: '';\n  }\n}\n\n.content {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: flex-start;\n\n  @media (--desktop) {\n    align-items: center;\n  }\n}\n\n.content h5,\n.content h5 a,\n.content h5 small,\n.content h5 button {\n  font-size: inherit;\n  line-height: 1.07;\n\n  @media (--desktop) {\n    line-height: 1.2;\n  }\n}\n\n.content h5,\n.content h5 div,\n.content h5 strong {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.content h5 {\n  flex: 1;\n  margin-top: 0;\n  margin-bottom: 0;\n  font-weight: 400;\n\n  @media (--desktop) {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n  }\n}\n\n.content h5[disabled] {\n  color: #b0b4c2;\n}\n\n.content h5 strong {\n  font-weight: 500;\n}\n\n.content h5 small {\n  color: #b0b4c2;\n}\n\n.content h5 a,\n.content h5 button {\n  display: inline-block;\n  border: 0 !important;\n  outline: 0;\n  margin: initial;\n  padding: initial;\n  background-color: transparent;\n  font-weight: 400;\n  text-align: left;\n  cursor: pointer;\n\n  @media (--desktop) {\n    white-space: nowrap;\n  }\n}\n\n.content h5 div > svg {\n  margin-left: 5px;\n}\n\n.content h5 button svg {\n  vertical-align: top;\n}\n\n.content > :nth-child(1n + 2):not(span) {\n  margin-left: 20px;\n}\n\n.content h5 > :nth-child(1n + 2) {\n  display: inline-block;\n  margin-top: 15px;\n\n  @media (--desktop) {\n    display: inherit;\n    margin-top: 0;\n  }\n\n  & > :nth-child(1n + 2) {\n    margin-top: 0;\n    margin-left: 15px;\n  }\n}\n\n.content h5 > :first-child > :nth-child(1n + 2):not(svg) {\n  display: block;\n  margin-top: 5px;\n\n  @media (--desktop) {\n    display: inline-block;\n    margin-top: 0;\n    margin-left: 15px;\n  }\n}\n\n.footer {\n  margin-top: 5px;\n  line-height: 1.07;\n\n  @media (--desktop) {\n    line-height: 1.2;\n  }\n\n  & > span {\n    display: block;\n    width: 100%;\n    margin-top: 20px;\n    color: var(--failureForeground);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `src-components-ProfileItem-styles--root--pZ5d3`,
	"content": `src-components-ProfileItem-styles--content--xEXjI`,
	"footer": `src-components-ProfileItem-styles--footer--wlDTW`
};
module.exports = ___CSS_LOADER_EXPORT___;
